import React from 'react'

export const U_PATH =
  'M16 18 C 10 36, 11 57, 26 61 C 41 65, 49 48, 39 41 C 29 34, 20 44, 28 54 C 36 64, 53 62, 60 50 C 64 42, 62 33, 58 27'

export default function UMark({ className = '', strokeWidth = 6, animated = false }) {
  return (
    <svg viewBox="0 0 72 76" fill="none" className={className} aria-hidden="true">
      <path
        d={U_PATH}
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        {...(animated
          ? {
              initial: { pathLength: 0 },
              whileInView: { pathLength: 1 },
              viewport: { once: true, amount: 0.4 },
              transition: { duration: 2.2, ease: [0.16, 1, 0.3, 1] },
            }
          : {})}
      />
    </svg>
  )
}
